var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8690fa",
    d: "M16 31a15 15 0 1 1 15-15 15 15 0 0 1-15 15Zm0-29a14 14 0 1 0 14 14A14 14 0 0 0 16 2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "#cfd2fc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 4.8,
    fill: "#8690fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8690fa",
    d: "M24.21 24.05a8.79 8.79 0 0 0-16.42 0 .8.8 0 0 0 .21.88 12 12 0 0 0 16 0 .8.8 0 0 0 .21-.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.a0018bf2ed0ce5ecf4dadf067eeb034d.svg";
export { ForwardRef as ReactComponent };